import React from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

interface AllServicesListProps {
  servicesColumns: any[][];
  getHealthIcon: ({ health }: { health: string | undefined }) => JSX.Element;
  handleOpenServiceDetail: (serviceName: string) => void;
}

export default function AllServicesList({
  servicesColumns,
  getHealthIcon,
  handleOpenServiceDetail,
}: AllServicesListProps) {
  return (
    <div className="mt-4">
      <div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {servicesColumns.map((column) => (
            <div
              key={column[0]?.service || Math.random()}
              className="space-y-2"
            >
              {column.map((service) => (
                <div key={service?.service} className="flex items-center">
                  {getHealthIcon({ health: service?.health })}
                  <span className="ml-2 flex-grow">{service?.service}</span>
                  <button
                    type="button"
                    onClick={() => handleOpenServiceDetail(service?.service)}
                    className="p-1 text-gray-500 hover:text-gray-700 focus:outline-none"
                    aria-label={`Details for ${service?.service}`}
                  >
                    <MagnifyingGlassIcon className="h-5 w-5" />
                  </button>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
